import React, { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { HiOutlineTicket } from "react-icons/hi";
import { MdExpandMore } from "react-icons/md";
import useMethodAccount from "../../../MyAccount/hooks/useMethodAccount";
import EASkeletonLoader from "../../../shared/EASkeletonLoader";
import EAButton from "../../../shared/Buttons/EAButton";
import SinglePass from "./SinglePass";
import { filterTicketsByStatus, getTicketStatusSummary } from "../../../../utils/TicketPassHelper";
import { Ticket } from "../../../../models/Ticket";

const ITEMS_PER_PAGE = 8;

const PassesList: React.FC = () => {
  const { t } = useTranslation();
  const { passes, getLimited, ticketsLoading } = useMethodAccount();
  const [displayedActiveCount, setDisplayedActiveCount] = useState(ITEMS_PER_PAGE);
  const [displayedExpiredCount, setDisplayedExpiredCount] = useState(ITEMS_PER_PAGE);

  const { active, expired } = useMemo(() => filterTicketsByStatus(passes), [passes]);

  useEffect(() => {
    getLimited();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  /**
   * Sortuje bilety: najpierw te które wymagają akcji (status error/warning)
   */
  const sortPassesByStatus = (passes: Ticket[]): Ticket[] => {
    return [...passes].sort((a, b) => {
      const statusA = getTicketStatusSummary(a);
      const statusB = getTicketStatusSummary(b);

      const priorityA = statusA.color === "error" ? 0 : statusA.color === "warning" ? 1 : 2;
      const priorityB = statusB.color === "error" ? 0 : statusB.color === "warning" ? 1 : 2;

      return priorityA - priorityB;
    });
  };

  const sortedActive = useMemo(() => sortPassesByStatus(active), [active]);
  const sortedExpired = useMemo(() => sortPassesByStatus(expired), [expired]);

  if (ticketsLoading) {
    return <EASkeletonLoader height="120px" />;
  }

  return (
    <div className="list-container">
      {/* SEKCJA: AKTYWNE BILETY/KARNETY */}
      
      {/* <EAChip label={t("aktywne")}  variant="success" /> */}
      <span className="text-size-body-large text-color-primary text-icon-align-center">
        <HiOutlineTicket /> <b>{t("aktywne")}</b>


      </span>
      <div className="list-wrapper">
        {sortedActive.length > 0 ? (
          <>
            {sortedActive.slice(0, displayedActiveCount).map((ticket) => (
              <SinglePass key={ticket.trhId} pass={ticket} onRefreshTickets={getLimited} />
            ))}
            {displayedActiveCount < sortedActive.length && (
              <div style={{ display: "flex", justifyContent: "center", marginTop: "16px" }}>
                <EAButton
                  title={t("pokaz_wiecej")}
                  variant="outlined"
                  endIcon={<MdExpandMore />}
                  onClick={() => setDisplayedActiveCount(displayedActiveCount + ITEMS_PER_PAGE)}
                />
              </div>
            )}
          </>
        ) : (
          <span className="text-size-body-small text-color-dark-gray text-icon-align-center">{t("brak_biletow")}</span>
        )}
      </div>

      {/* SEKCJA: WYGASŁE BILETY/KARNETY */}
      <span className="text-size-body-large text-color-dark-gray text-icon-align-center">
        <HiOutlineTicket /> <b>{t("Wygasłe")}</b>
      </span>
      {sortedExpired.length > 0 ? (
        <div className="list-wrapper">
          {sortedExpired.slice(0, displayedExpiredCount).map((ticket) => (
            <SinglePass key={ticket.trhId} pass={ticket} onRefreshTickets={getLimited} />
          ))}
          {displayedExpiredCount < sortedExpired.length && (
            <div style={{ display: "flex", justifyContent: "center", marginTop: "16px" }}>
              <EAButton
                title={t("pokaz_starsze")}
                variant="outlined"
                endIcon={<MdExpandMore />}
                onClick={() => setDisplayedExpiredCount(displayedExpiredCount + ITEMS_PER_PAGE)}
              />
            </div>
          )}
        </div>
      ) : (
        <span className="text-size-body-small text-color-dark-gray text-icon-align-center">{t("brak_biletow")}</span>
      )}
    </div>
  );
};

export default PassesList;
